import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Shirt, TrendingUp, Zap, ArrowRight, ShieldCheck } from 'lucide-react';

export default function LoginPage() {
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();

  if (user) {
    navigate(user.role === 'startup' ? '/dashboard/startup' : '/my-tshirt');
    return null;
  }

  const handleLogin = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google?t=${Date.now()}`;
  };


  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F6F1E8' }}>
      <div className="w-full max-w-lg">
        {/* Main card */}
        <div className="bg-[#EDE3C7] border-[3px] border-[#121212] shadow-[8px_8px_0px_0px_#121212] rounded-2xl overflow-hidden">
          {/* Top brand strip */}
          <div className="bg-[#121212] px-8 py-6 text-center">
            <div className="flex items-center justify-center gap-3 mb-2">
              <Shirt className="w-8 h-8 text-[#FF6B6B]" strokeWidth={3} />
              <h1 className="text-3xl font-black uppercase tracking-tighter text-[#F6F1E8]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                The SurfaceArea Project
              </h1>
            </div>
            <p className="text-sm font-medium text-[#888]">
              The live exchange for startup tees
            </p>
          </div>

          <div className="px-8 py-8">
            {/* Value props */}
            <div className="space-y-3 mb-8">
              {[
                { icon: Zap, text: 'Name your price for wearing startup gear', color: '#FF6B6B' },
                { icon: TrendingUp, text: 'Startups compete for your attention', color: '#6EE7B7' },
                { icon: Shirt, text: 'Get paid to rep the brands you love', color: '#E8C86A' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg border-[2px] border-[#121212] flex items-center justify-center flex-shrink-0" style={{ backgroundColor: item.color }}>
                    <item.icon className="w-4 h-4 text-[#121212]" strokeWidth={3} />
                  </div>
                  <span className="text-sm font-bold">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Google Sign In */}
            <button
              data-testid="google-login-btn"
              onClick={handleLogin}
              className="w-full bg-white text-[#121212] font-bold border-[3px] border-[#121212] shadow-[4px_4px_0px_0px_#121212] hover:-translate-y-[2px] hover:-translate-x-[2px] hover:shadow-[6px_6px_0px_0px_#121212] active:translate-y-[4px] active:translate-x-[4px] active:shadow-none transition-all rounded-xl px-6 py-4 text-base flex items-center justify-center gap-3"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" /><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" /><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" /><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" /></svg>
              Continue with Google
            </button>

            <div className="flex items-center justify-center gap-2 mt-4 text-xs font-medium" style={{ color: '#aaa' }}>
              <ShieldCheck className="w-3.5 h-3.5" strokeWidth={2} />
              <span>Secure sign-in powered by Google</span>
            </div>
          </div>
        </div>

        {/* Browse link */}
        <div className="text-center mt-6">
          <button
            data-testid="browse-without-login"
            onClick={() => navigate('/')}
            className="text-sm font-bold hover:text-[#FF6B6B] transition-colors flex items-center gap-2 mx-auto"
          >
            Just browsing? Skip to the market <ArrowRight className="w-4 h-4" strokeWidth={3} />
          </button>
        </div>
      </div>
    </div>
  );
}
